import { render, staticRenderFns } from "./RootTipiStudenteView.vue?vue&type=template&id=44a69d3b&"
import script from "./RootTipiStudenteView.vue?vue&type=script&lang=ts&"
export * from "./RootTipiStudenteView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports